// extracted by mini-css-extract-plugin
module.exports = {"icon":"word-count-module--icon--2Y9Ub","container":"word-count-module--container--1kG0l","divider":"word-count-module--divider--3W0vN"};